import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";

@Component({
  selector: "ngx-item-category-select-form",
  templateUrl: "./item-category-select-form.component.html",
  styleUrls: ["./item-category-select-form.component.scss"],
})
export class ItemCategorySelectFormComponent extends BaseFormComponent<any> {
  images: string[] = [];
  selectedImage: number;
  image: string;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.getImages();
  }

  public select(i: any): void {
    this.selectedImage = i;
  }

  public onSubmit(): void {
    this.result = this.images[this.selectedImage];
    this.closeModal();
  }

  private getImages(): void {
    this.httpCommonService
      .get("ItemCategory/ItemCategoriesImage")
      .pipe(take(1))
      .subscribe((data: any) => {
        this.images = data;
        this.selectedImage = this.images.findIndex((x) => x === this.image);
      });
  }
}
